import dok from '../../../web/src/lib/jogi/dokumentumok.json';

// A publikus oldal címe környezetenként; alapértelmezés az éles domain (mint a SuperIrodaSzerkesztőben).
const PUBLIKUS_ALAP = ((import.meta.env.VITE_PUBLIKUS_ALAP as string | undefined) ?? 'https://ingatlanertekmeghatarozas.hu').replace(/\/+$/, '');

export interface JogiDokumentum { verzio: string; url: string }
export interface JogiAllapot { aszf: JogiDokumentum; adatvedelem: JogiDokumentum }

function aktualis(slug: 'partner-aszf' | 'adatvedelem'): JogiDokumentum {
  const d = dok.dokumentumok.find((x) => x.slug === slug);
  // Néma hibaág nincs: hiányzó verzióval az űrlap nem küldhető be értelmesen.
  if (!d) throw new Error(`Hiányzó jogi dokumentum: ${slug}`);
  return { verzio: d.aktualis_verzio, url: `${PUBLIKUS_ALAP}${d.url}` };
}

/** Az űrlapon megjelenített (és a beküldéssel rögzített) partner-ÁSZF és adatvédelmi tájékoztató verziója. */
export function jogiAllapot(): JogiAllapot {
  return { aszf: aktualis('partner-aszf'), adatvedelem: aktualis('adatvedelem') };
}

/**
 * A partner-ÁSZF 13.5. pontjának kiemelt feltételei (Ptk. 6:78. § (2): külön figyelemfelhívás). A szöveg a
 * `partner-aszf.astro`-val egyezik; a teszt jelez, ha a 13.5. pont bővül vagy módosul.
 */
export const KIEMELT_FELTETELEK: string[] = [
  'a felelősség korlátozása (9.1.)',
  'a díjazás egyedi megállapodás szerinti módosítása (5.2.)',
  'a kampányok szüneteltetése fizetési késedelem esetén (5.5.)',
  'az azonnali hatályú felmondás különös esetei (10.4.)',
  'a minőségellenőrzés és a valótlan státuszadat következményei, köztük az azonnali hatályú felmondás joga és a kártérítési igény (4.8.)',
  'az ÁSZF egyoldalú módosításának joga (13.3.)',
  'az adatfeldolgozókra vonatkozó általános felhatalmazás (8.10.)',
];
